<template>
    <div class="main" :style="mainStyle">
      <img style="height: 6rem;
      margin: 10px;
      user-select: none;
      border-radius: inherit;" src="https://admin.vinapp.co/images/logo-vinapp.jpg?25ab23fce2528af78800c6664df46195" alt="Logo Vinapp" />
      <br>
      <!--<h2 style="color:#EEEEEE; margin: 10px; font-weight: 1000!important;">Gestión de Mesas</h2>-->
      <input class="login-input"
        type="text"
        name="username"
        id="username"
        :placeholder="(active_login_with_code == 'false') ? 'Usuario' : 'Nombre Mesero'"
        v-model="nombre_mesero"
      />
      <br />
      <input class="login-input"
        type="password"
        name="password"
        id="password"
        :placeholder="(active_login_with_code == 'false') ? 'Contraseña' : 'Código de Acceso'"
        v-model="code_login"
      />
      <br />
      <input class="login-input button"
        type="button"
        value="Ingresar"
        id="done"
        @click="login()"
      />
      <small v-show="errorLogin" style="color:red;font-weight: 900!important;">{{errorLogin}}</small>
      <br />
      <div style="width: 100%;
      text-align: center;
      padding-top: 30px;">
        <h4 style=" font-size: 1rem;
        font-weight: 900;
        font-family: 'Poppins', sans-serif;
        color: #fff;">Tecnología <a style="color: #0051a9!important;
            text-decoration: none;
            background-color: transparent;" href="https://info.vinapp.co" target="_blank">VinApp</a></h4>
      </div>
      
    </div>
  </template>
  
  <script>
    import axios from 'axios';
  export default {
    name: "LoginTable",
    data() {
        return {
            nombre_mesero:localStorage.getItem('nombre_mesero'),
            code_login:null,
            id_company:localStorage.getItem('id_company'),
            errorLogin:null,
            active_login_with_code: localStorage.getItem('active_login_with_code'),
        }
    },
    //Custom style for main and input for make the page responsive:
    props: {
      mainStyle: String,
      inputStyle: String,
    },
    methods:{
        login(){
          let storage = localStorage;
          //let company = storage.id_company;
          let active_login_with_code = storage.active_login_with_code;
          //console.log('muestra company: ' + storage.id_company);
          if(active_login_with_code == 'true'){ 
            axios.get('https://back.vinapp.co/api/company/validate-code/'+this.id_company+'/'+this.code_login)
            .then(res=>{
              console.log(res.data)
              if(res.data.status==200){
                  localStorage.setItem('loginStatus', true);
                  localStorage.setItem('code_login', this.code_login);
                  localStorage.setItem('nombre_mesero', this.nombre_mesero);
                  window.location.reload(true);
              } else{
                  this.errorLogin=res.data.message
              }
            }).catch(err=>{
                console.log(err)
                this.errorLogin="Error al intentar ingresar, por favor intete mas tarde."
                localStorage.setItem('loginStatus', false);
            });
          } else {
            
            let request = {
              email: this.nombre_mesero,
              password: this.code_login
            }
            axios.post('https://back.vinapp.co/api/authenticate', request)
            .then(res => {
              if(res.data.success == true){
                let code = res.data.licencia.code_login;
                if(res.data.user.id_tipo_rol == 160){
                  localStorage.setItem('loginStatus', true);
                  localStorage.setItem('code_login', code);
                  localStorage.setItem('nombre_mesero', res.data.user.name);
                  localStorage.setItem('id_user_mesero', res.data.user.id);
                  localStorage.setItem('punto', res.data.user.name_point);
                  localStorage.setItem('id_punto_company', res.data.user.id_point);
                  window.location.reload(true);
                }else{
                  this.errorLogin="El usuario no es un mesero."
                  localStorage.setItem('loginStatus', false);
                }
                
              }else{
                this.errorLogin="Credenciales Invalidas."
                localStorage.setItem('loginStatus', false);
              }
            })
            .catch(err => {
              console.log(err)
              this.errorLogin="Error al intentar ingresar, por favor intete mas tarde."
              localStorage.setItem('loginStatus', false);
            })
          }
        }
    },
    mounted(){
    }
  };
  </script>
  
  <style>
  /* Import Poppins font: */
  @import url("https://fonts.googleapis.com/css2?family=Poppins&display=swap");
  
  .main {
    background: rgba(255, 255, 255, 0.4);
    position: absolute;
    top: 20%;
    left: 30%;
    width: 40%;
    text-align: center;
    padding: 5px;
    border-radius: 3rem;
    box-shadow: 0px 0px 8px -5px #000000;
    padding-top: 3%;
    padding-bottom: 5%;
    font-family: "Poppins", sans-serif;
  }
  
  .login h1 {
    cursor: default;
    user-select: none;
  }
  .login h2 {
    cursor: default;
    user-select: none;
  }
  
  .login-input {
    border-radius: 3rem;
    border: none;
    padding: 10px;
    text-align: center;
    outline: none;
    margin: 10px!important;
    width: 80%;
    box-sizing: border-box;
    font-family: "Poppins", sans-serif;
    font-weight: 400;
  }
  
  .login-input:hover {
    box-shadow: 0px 0px 8px -5px #000000;
  }
  
  .login-input:active {
    box-shadow: 0px 0px 8px -5px #000000;
  }
  
  #done {
    background: #60e8ca;
  }
  
  .button {
    cursor: pointer;
    user-select: none;
  }

  </style>